﻿import {ensureErrorType, HttpClient} from "@2d-front-monorepo/core";
import {AttachmentId} from "../../nominalTypes/AttachmentId";
import IPermitsFiles from "../IPermitsFiles";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsFiles implements IPermitsFiles {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	async create(formData: FormData, signal?: AbortSignal | undefined): Promise<AttachmentId> {
		return this._client.jsonFetch("files", "POST", formData, {
			signal: signal
		});
	}

	async get(blobId: string, signal?: AbortSignal | undefined): Promise<Blob> {
		let result = await this._client.fetch(`files/${blobId}`, "GET", null, {
			signal: signal
		});
		try {
			return await result.response.blob();
		} catch (__e) {
			const e: Error = ensureErrorType(__e);
			throw HttpClient.errorFromError(e, result);
		}
	}

	async mergeImages(formData: FormData, signal?: AbortSignal | undefined): Promise<Blob> {
		let result = await this._client.fetch("files/merge-images", "POST", formData, {
			signal: signal
		});
		try {
			return await result.response.blob();
		} catch (__e) {
			const e: Error = ensureErrorType(__e);
			throw HttpClient.errorFromError(e, result);
		}
	}

	update(attachmentId: string, formData: FormData, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch(`files/${attachmentId}`, "PUT", formData, {
			signal: signal
		});
	}
}
